import React from 'react';
import css from './index.module.scss';
import csx from 'classnames';

interface Iphone {
  width?: string;
  height?: string;
  imgUrl: string;
  horizontal?: boolean;
  className?: string;
}

export const Iphone = ({
  width = '722',
  height = '360',
  className,
  ...props
}: Iphone) => {
  const imgId = props.imgUrl;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="360"
      height="722"
      version="1.1"
      viewBox="0 0 95.25 191.029"
      className={csx(css.container, className, {
        [css.horizontal]: props.horizontal,
      })}
    >
      <defs>
        <linearGradient id="linearGradient948">
          <stop offset="0" stopColor="#404040" stopOpacity="1"></stop>
          <stop
            offset="0.022"
            stopColor="#464646"
            stopOpacity="1"
          ></stop>
          <stop
            offset="0.999"
            stopColor="#525252"
            stopOpacity="0.016"
          ></stop>
          <stop offset="1" stopColor="#444" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient id="linearGradient5830">
          <stop
            offset="0"
            stopColor="#4f4f4f"
            stopOpacity="0.131"
          ></stop>
          <stop
            offset="0.07"
            stopColor="#4f4f4f"
            stopOpacity="1"
          ></stop>
          <stop
            offset="0.937"
            stopColor="#4f4f4f"
            stopOpacity="0.953"
          ></stop>
          <stop offset="1" stopColor="#4f4f4f" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient id="linearGradient5750">
          <stop
            offset="0"
            stopColor="#cbcbcb"
            stopOpacity="0.275"
          ></stop>
          <stop
            offset="0.04"
            stopColor="#cbcbcb"
            stopOpacity="1"
          ></stop>
          <stop
            offset="0.96"
            stopColor="#cbcbcb"
            stopOpacity="1"
          ></stop>
          <stop
            offset="1"
            stopColor="#cbcbcb"
            stopOpacity="0.276"
          ></stop>
        </linearGradient>
        <linearGradient id="linearGradient5473-6">
          <stop
            offset="0"
            stopColor="#cbcbcb"
            stopOpacity="0.275"
          ></stop>
          <stop
            offset="0.05"
            stopColor="#cbcbcb"
            stopOpacity="1"
          ></stop>
          <stop
            offset="0.95"
            stopColor="#cbcbcb"
            stopOpacity="1"
          ></stop>
          <stop
            offset="1"
            stopColor="#cbcbcb"
            stopOpacity="0.276"
          ></stop>
        </linearGradient>
        <linearGradient id="linearGradient5220">
          <stop offset="0" stopColor="#404040" stopOpacity="1"></stop>
          <stop
            offset="0.6"
            stopColor="#838383"
            stopOpacity="1"
          ></stop>
          <stop offset="1" stopColor="#a7a7a7" stopOpacity="1"></stop>
        </linearGradient>
        <linearGradient>
          <stop offset="0" stopColor="#000" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#000" stopOpacity="0"></stop>
        </linearGradient>
        <clipPath id="clipPath4960" clipPathUnits="userSpaceOnUse">
          <path
            style={{ marker: 'none' }}
            fill="#ebebeb"
            fillOpacity="1"
            fillRule="nonzero"
            stroke="none"
            strokeDasharray="none"
            strokeDashoffset="0"
            strokeLinecap="round"
            strokeLinejoin="miter"
            strokeMiterlimit="4"
            strokeOpacity="1"
            strokeWidth="1.276"
            d="M56.734 2.014c-29.678 0-53.572 23.893-53.572 53.572v610.443c0 29.679 23.894 53.573 53.572 53.573h246.532c29.678 0 53.572-23.894 53.572-53.573V55.586c0-29.679-23.894-53.572-53.572-53.572zm-1.423 3.978h249.378c26.583 0 47.983 21.398 47.983 47.98V668.21c0 26.582-21.4 47.982-47.983 47.982H55.311c-26.583 0-47.983-21.4-47.983-47.982V53.973c0-26.583 21.4-47.98 47.983-47.98z"
            color="#000"
            display="inline"
            enableBackground="accumulate"
            opacity="1"
            overflow="visible"
            vectorEffect="none"
            visibility="visible"
          ></path>
        </clipPath>
        <filter
          id="filter4996"
          width="1.003"
          height="1.002"
          x="-0.002"
          y="-0.001"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="0.266"></feGaussianBlur>
        </filter>
        <clipPath clipPathUnits="userSpaceOnUse">
          <path
            style={{ marker: 'none' }}
            fill="#ebebeb"
            fillOpacity="1"
            fillRule="nonzero"
            stroke="none"
            strokeDasharray="none"
            strokeDashoffset="0"
            strokeLinecap="round"
            strokeLinejoin="miter"
            strokeMiterlimit="4"
            strokeOpacity="1"
            strokeWidth="1.276"
            d="M56.734 2.014c-29.678 0-53.572 23.893-53.572 53.572v610.443c0 29.679 23.894 53.573 53.572 53.573h246.532c29.678 0 53.572-23.894 53.572-53.573V55.586c0-29.679-23.894-53.572-53.572-53.572zm-1.423 3.978h249.378c26.583 0 47.983 21.398 47.983 47.98V668.21c0 26.582-21.4 47.982-47.983 47.982H55.311c-26.583 0-47.983-21.4-47.983-47.982V53.973c0-26.583 21.4-47.98 47.983-47.98z"
            color="#000"
            display="inline"
            enableBackground="accumulate"
            opacity="1"
            overflow="visible"
            vectorEffect="none"
            visibility="visible"
          ></path>
        </clipPath>
        <linearGradient
          id="linearGradient5226"
          x1="340.652"
          x2="349.574"
          y1="361.123"
          y2="361.123"
          gradientUnits="userSpaceOnUse"
          xlinkHref="#linearGradient5220"
        ></linearGradient>
        <linearGradient
          id="linearGradient5226-6"
          x1="340.652"
          x2="349.574"
          y1="361.123"
          y2="361.123"
          gradientTransform="matrix(-.26458 0 0 .26458 95.476 0)"
          gradientUnits="userSpaceOnUse"
          xlinkHref="#linearGradient5220"
        ></linearGradient>
        <filter
          id="filter5343"
          width="1.385"
          height="1.165"
          x="-0.192"
          y="-0.082"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="0.031"></feGaussianBlur>
        </filter>
        <filter
          id="filter5347"
          width="1.218"
          height="1.165"
          x="-0.109"
          y="-0.082"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="0.031"></feGaussianBlur>
        </filter>
        <clipPath id="clipPath5401" clipPathUnits="userSpaceOnUse">
          <rect
            style={{ marker: 'none' }}
            width="4.377"
            height="7.417"
            x="-13.878"
            y="25.857"
            fill="#000"
            fillOpacity="1"
            fillRule="nonzero"
            stroke="none"
            strokeDasharray="none"
            strokeDashoffset="0"
            strokeLinecap="round"
            strokeLinejoin="miter"
            strokeMiterlimit="4"
            strokeOpacity="1"
            strokeWidth="0.026"
            color="#000"
            display="inline"
            enableBackground="accumulate"
            opacity="1"
            overflow="visible"
            ry="0.451"
            vectorEffect="none"
            visibility="visible"
          ></rect>
        </clipPath>
        <filter
          id="filter5465"
          width="1.65"
          height="1.052"
          x="-0.325"
          y="-0.026"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="0.071"></feGaussianBlur>
        </filter>
        <linearGradient
          id="linearGradient5475"
          x1="-13.206"
          x2="-13.206"
          y1="26.259"
          y2="32.871"
          gradientUnits="userSpaceOnUse"
          xlinkHref="#linearGradient5473-6"
        ></linearGradient>
        <linearGradient
          id="linearGradient5475-9"
          x1="-13.206"
          x2="-13.206"
          y1="26.259"
          y2="39.269"
          gradientTransform="translate(13.878 13.831)"
          gradientUnits="userSpaceOnUse"
          xlinkHref="#linearGradient5473-6"
        ></linearGradient>
        <filter
          id="filter5465-7"
          width="1.65"
          height="1.052"
          x="-0.325"
          y="-0.026"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="0.071"></feGaussianBlur>
        </filter>
        <clipPath id="clipPath5589" clipPathUnits="userSpaceOnUse">
          <path
            d="M.451 39.688a.45.45 0 00-.451.45v12.913c0 .25.201.451.451.451h3.474a.45.45 0 00.451-.45V40.138a.45.45 0 00-.45-.451z"
            style={{ marker: 'none' }}
            fill="#000"
            fillOpacity="1"
            fillRule="nonzero"
            stroke="none"
            strokeDasharray="none"
            strokeDashoffset="0"
            strokeLinecap="round"
            strokeLinejoin="miter"
            strokeMiterlimit="4"
            strokeOpacity="1"
            strokeWidth="0.026"
            color="#000"
            display="inline"
            enableBackground="accumulate"
            opacity="1"
            overflow="visible"
            vectorEffect="none"
            visibility="visible"
          ></path>
        </clipPath>
        <clipPath id="clipPath5589-7" clipPathUnits="userSpaceOnUse">
          <path
            d="M.451 39.688a.45.45 0 00-.451.45v12.913c0 .25.201.451.451.451h3.474a.45.45 0 00.451-.45V40.138a.45.45 0 00-.45-.451z"
            style={{ marker: 'none' }}
            fill="#000"
            fillOpacity="1"
            fillRule="nonzero"
            stroke="none"
            strokeDasharray="none"
            strokeDashoffset="0"
            strokeLinecap="round"
            strokeLinejoin="miter"
            strokeMiterlimit="4"
            strokeOpacity="1"
            strokeWidth="0.026"
            color="#000"
            display="inline"
            enableBackground="accumulate"
            opacity="1"
            overflow="visible"
            vectorEffect="none"
            visibility="visible"
          ></path>
        </clipPath>
        <filter
          id="filter5465-7-8"
          width="1.65"
          height="1.052"
          x="-0.325"
          y="-0.026"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="0.071"></feGaussianBlur>
        </filter>
        <linearGradient
          id="linearGradient5671"
          x1="-13.206"
          x2="-13.206"
          y1="26.259"
          y2="39.269"
          gradientTransform="translate(13.878 13.831)"
          gradientUnits="userSpaceOnUse"
          xlinkHref="#linearGradient5473-6"
        ></linearGradient>
        <filter
          id="filter5465-7-2"
          width="1.65"
          height="1.052"
          x="-0.325"
          y="-0.026"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="0.071"></feGaussianBlur>
        </filter>
        <linearGradient
          id="linearGradient5697"
          x1="-13.206"
          x2="-13.206"
          y1="26.259"
          y2="47.301"
          gradientTransform="translate(13.878 13.831)"
          gradientUnits="userSpaceOnUse"
          xlinkHref="#linearGradient5750"
        ></linearGradient>
        <clipPath id="clipPath5738" clipPathUnits="userSpaceOnUse">
          <path
            d="M.451 39.688a.45.45 0 00-.451.45v20.945c0 .25.201.451.451.451h3.474a.45.45 0 00.451-.45V40.138a.45.45 0 00-.45-.451z"
            style={{ marker: 'none' }}
            fill="#000"
            fillOpacity="1"
            fillRule="nonzero"
            stroke="none"
            strokeDasharray="none"
            strokeDashoffset="0"
            strokeLinecap="round"
            strokeLinejoin="miter"
            strokeMiterlimit="4"
            strokeOpacity="1"
            strokeWidth="0.026"
            color="#000"
            display="inline"
            enableBackground="accumulate"
            opacity="1"
            overflow="visible"
            vectorEffect="none"
            visibility="visible"
          ></path>
        </clipPath>
        <linearGradient
          id="linearGradient5832"
          x1="8.315"
          x2="86.935"
          y1="8.48"
          y2="8.48"
          gradientTransform="translate(.067 -2.606)"
          gradientUnits="userSpaceOnUse"
          xlinkHref="#linearGradient5830"
        ></linearGradient>
        <linearGradient
          id="linearGradient5832-3"
          x1="8.315"
          x2="86.935"
          y1="8.48"
          y2="8.48"
          gradientTransform="matrix(1 0 0 -1 .067 193.567)"
          gradientUnits="userSpaceOnUse"
          xlinkHref="#linearGradient5830"
        ></linearGradient>
        <linearGradient
          id="linearGradient4693"
          x1="304.221"
          x2="303.21"
          y1="22.201"
          y2="920.095"
          gradientUnits="userSpaceOnUse"
          xlinkHref="#linearGradient948"
        ></linearGradient>
        <pattern
          id={imgId}
          patternUnits="userSpaceOnUse"
          height={SCREEN_HEIGHT}
          width={SCREEN_WIDTH}
          className={css.img}
          viewBox={`0 ${TOP_MARGIN} ${SCREEN_WIDTH} ${SCREEN_HEIGHT}`}
        >
          <image
            href={props.imgUrl}
            height={SCREEN_HEIGHT}
            width={SCREEN_WIDTH}
            preserveAspectRatio="xMinYMid slice"
            // preserveAspectRatio="none"
          />
        </pattern>
      </defs>
      <g stroke="none" strokeLinejoin="miter">
        <g
          fillOpacity="1"
          fillRule="nonzero"
          strokeDasharray="none"
          strokeDashoffset="0"
          strokeLinecap="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          color="#000"
          visibility="visible"
        >
          <path
            style={{ marker: 'none' }}
            fill="#000"
            strokeWidth="0.026"
            d="M94.799 44.206c.25 0 .451.201.451.451v20.945a.45.45 0 01-.451.45h-3.474a.45.45 0 01-.451-.45V44.657c0-.25.2-.45.45-.45z"
            display="inline"
            enableBackground="accumulate"
            opacity="1"
            overflow="visible"
            vectorEffect="none"
          ></path>
          <path
            fill="url(#linearGradient5697)"
            strokeWidth="0.024"
            d="M.547 40.09a.401.401 0 00-.402.402V60.73c0 .223.18.402.402.402h.125V40.09z"
            clipPath="url(#clipPath5738)"
            enableBackground="accumulate"
            filter="url(#filter5465-7-2)"
            opacity="1"
            overflow="visible"
            transform="matrix(-1 0 0 1 95.25 4.518)"
            style={{ marker: 'none' }}
            display="inline"
            vectorEffect="none"
          ></path>
        </g>
        <g
          fillOpacity="1"
          fillRule="nonzero"
          strokeDasharray="none"
          strokeDashoffset="0"
          strokeLinecap="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          color="#000"
          transform="translate(.014)"
          visibility="visible"
        >
          <rect
            width="4.377"
            height="7.417"
            x="-0.014"
            y="25.857"
            fill="#000"
            strokeWidth="0.026"
            display="inline"
            enableBackground="accumulate"
            opacity="1"
            overflow="visible"
            ry="0.451"
            style={{ marker: 'none' }}
            vectorEffect="none"
          ></rect>
          <path
            fill="url(#linearGradient5475)"
            strokeWidth="0.024"
            d="M-13.33 26.259a.401.401 0 00-.403.402v5.808c0 .223.18.402.402.402h.125v-6.612z"
            clipPath="url(#clipPath5401)"
            enableBackground="accumulate"
            filter="url(#filter5465)"
            opacity="1"
            overflow="visible"
            transform="translate(13.864)"
            style={{ marker: 'none' }}
            display="inline"
            vectorEffect="none"
          ></path>
        </g>
        <g
          fillOpacity="1"
          fillRule="nonzero"
          strokeDasharray="none"
          strokeDashoffset="0"
          strokeLinecap="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          color="#000"
          visibility="visible"
        >
          <path
            style={{ marker: 'none' }}
            fill="#000"
            strokeWidth="0.026"
            d="M.451 39.688a.45.45 0 00-.451.45v12.913c0 .25.201.451.451.451h3.474a.45.45 0 00.451-.45V40.138a.45.45 0 00-.45-.451z"
            display="inline"
            enableBackground="accumulate"
            opacity="1"
            overflow="visible"
            vectorEffect="none"
          ></path>
          <path
            fill="url(#linearGradient5475-9)"
            d="M.547 40.09a.401.401 0 00-.402.402v12.206c0 .223.18.402.402.402h.125V40.09z"
            clipPath="url(#clipPath5589)"
            style={{ marker: 'none' }}
            strokeWidth="0.024"
            display="inline"
            enableBackground="accumulate"
            filter="url(#filter5465-7)"
            opacity="1"
            overflow="visible"
            vectorEffect="none"
          ></path>
        </g>
        <g
          fillOpacity="1"
          fillRule="nonzero"
          strokeDasharray="none"
          strokeDashoffset="0"
          strokeLinecap="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          color="#000"
          transform="translate(0 17.373)"
          visibility="visible"
        >
          <path
            style={{ marker: 'none' }}
            fill="#000"
            strokeWidth="0.026"
            d="M.451 39.688a.45.45 0 00-.451.45v12.913c0 .25.201.451.451.451h3.474a.45.45 0 00.451-.45V40.138a.45.45 0 00-.45-.451z"
            display="inline"
            enableBackground="accumulate"
            opacity="1"
            overflow="visible"
            vectorEffect="none"
          ></path>
          <path
            fill="url(#linearGradient5671)"
            d="M.547 40.09a.401.401 0 00-.402.402v12.206c0 .223.18.402.402.402h.125V40.09z"
            clipPath="url(#clipPath5589-7)"
            style={{ marker: 'none' }}
            strokeWidth="0.024"
            display="inline"
            enableBackground="accumulate"
            filter="url(#filter5465-7-8)"
            opacity="1"
            overflow="visible"
            vectorEffect="none"
          ></path>
        </g>
        <path
          style={{ marker: 'none' }}
          fill="#000"
          fillOpacity="1"
          fillRule="nonzero"
          strokeDasharray="none"
          strokeDashoffset="0"
          strokeLinecap="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="0.129"
          d="M14.483.199A13.934 13.934 0 00.52 14.163v162.634a13.934 13.934 0 0013.964 13.965h28.301l.578-.82h8.525l.58.82h28.3a13.934 13.934 0 0013.964-13.965V14.163A13.934 13.934 0 0080.767.2z"
          color="#000"
          display="inline"
          enableBackground="accumulate"
          opacity="1"
          overflow="visible"
          vectorEffect="none"
          visibility="visible"
        ></path>
        <g fillOpacity="1" strokeOpacity="1">
          <g
            fillRule="nonzero"
            strokeDasharray="none"
            strokeDashoffset="0"
            strokeLinecap="round"
            strokeMiterlimit="4"
            strokeWidth="0.338"
            color="#000"
            transform="translate(-244.341)"
            visibility="visible"
          >
            <path
              style={{ marker: 'none' }}
              fill="#7d7e7f"
              d="M245.178 19.826h1.102v-1.303h-1.102z"
              display="inline"
              enableBackground="accumulate"
              opacity="1"
              overflow="visible"
              vectorEffect="none"
            ></path>
            <path
              style={{ marker: 'none' }}
              fill="#ebebeb"
              d="M245.178 171.2h1.102V19.827h-1.102z"
              display="inline"
              enableBackground="accumulate"
              opacity="1"
              overflow="visible"
              vectorEffect="none"
            ></path>
            <path
              style={{ marker: 'none' }}
              fill="#7d7e7f"
              d="M245.178 172.504h1.102v-1.303h-1.102z"
              display="inline"
              enableBackground="accumulate"
              opacity="1"
              overflow="visible"
              vectorEffect="none"
            ></path>
            <path
              style={{ marker: 'none' }}
              fill="#ebebeb"
              d="M338.755 172.504h-1.103v4.36a12.668 12.668 0 01-12.695 12.695h-65.982a12.668 12.668 0 01-12.695-12.695v-4.36h-1.102v3.783a14.143 14.143 0 0014.174 14.174h65.228a14.143 14.143 0 0014.175-14.174z"
              display="inline"
              enableBackground="accumulate"
              opacity="1"
              overflow="visible"
              vectorEffect="none"
            ></path>
            <path
              style={{ marker: 'none' }}
              fill="#7d7e7f"
              d="M338.755 171.2h-1.103v1.304h1.103z"
              display="inline"
              enableBackground="accumulate"
              opacity="1"
              overflow="visible"
              vectorEffect="none"
            ></path>
            <path
              style={{ marker: 'none' }}
              fill="#ebebeb"
              d="M338.755 19.826h-1.103v151.375h1.103z"
              display="inline"
              enableBackground="accumulate"
              opacity="1"
              overflow="visible"
              vectorEffect="none"
            ></path>
            <path
              style={{ marker: 'none' }}
              fill="#7d7e7f"
              d="M338.755 18.523h-1.103v1.303h1.103z"
              display="inline"
              enableBackground="accumulate"
              opacity="1"
              overflow="visible"
              vectorEffect="none"
            ></path>
            <path
              style={{ marker: 'none' }}
              fill="#ebebeb"
              d="M259.352.6a14.143 14.143 0 00-14.174 14.174v3.75h1.102v-4.177a12.667 12.667 0 0112.695-12.695h65.982a12.667 12.667 0 0112.695 12.695v4.176h1.103v-3.75A14.143 14.143 0 00324.58.6z"
              display="inline"
              enableBackground="accumulate"
              opacity="1"
              overflow="visible"
              vectorEffect="none"
            ></path>
          </g>
          <path
            fill="#434343"
            fillRule="evenodd"
            strokeLinecap="butt"
            strokeWidth="1"
            d="M37.924 11.58c-6.587-.168-19.14 1.826-32.031 16.313-18.75 21.071-1.965 8.392-1.965 8.392s11.518-17.856 27.59-20.178c16.071-2.321 11.16-3.93 11.16-3.93s-1.76-.52-4.754-.597zm284.152 0c-2.994.076-4.754.598-4.754.598s-4.911 1.608 11.16 3.93c16.072 2.32 27.59 20.177 27.59 20.177s16.785 12.679-1.965-8.392c-12.89-14.487-25.444-16.48-32.03-16.313zM-2.439 681.941c-1.439-.172-.457 2.29 8.332 12.166 18.75 21.072 36.785 15.715 36.785 15.715s4.911-1.608-11.16-3.93c-16.072-2.32-27.59-20.177-27.59-20.177s-4.737-3.578-6.367-3.774zm364.878 0c-1.63.196-6.367 3.774-6.367 3.774s-11.518 17.856-27.59 20.178c-16.071 2.321-11.16 3.93-11.16 3.93s18.035 5.356 36.785-15.716c8.79-9.877 9.77-12.338 8.332-12.166z"
            clipPath="url(#clipPath4960)"
            filter="url(#filter4996)"
            transform="scale(.26458)"
          ></path>
        </g>
        <g
          fillOpacity="1"
          fillRule="nonzero"
          strokeDasharray="none"
          strokeDashoffset="0"
          strokeLinecap="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          color="#000"
          transform="translate(-.113)"
          visibility="visible"
        >
          <path
            fill="url(#linearGradient5226)"
            strokeWidth="6.689"
            d="M325.58 15.363c-1.174-.116-.62 1.055 2.016 3.496 8.696 8.055 14.095 19.714 14.095 32.692v619.144c0 12.978-5.4 24.637-14.095 32.692-2.636 2.441-3.19 3.612-2.016 3.496.705-.07 2.032-.603 3.904-1.602 12.71-6.78 20.09-21.408 20.09-36.945V53.91c0-15.537-7.38-30.165-20.09-36.945-1.872-.999-3.2-1.532-3.904-1.602z"
            display="inline"
            enableBackground="accumulate"
            opacity="1"
            transform="scale(.26458)"
            style={{ marker: 'none' }}
            overflow="visible"
            vectorEffect="none"
          ></path>
          <path
            fill="url(#linearGradient5226-6)"
            strokeWidth="1.77"
            d="M9.333 4.065c.311-.03.164.279-.533.925-2.3 2.131-3.73 5.216-3.73 8.65v163.815c0 3.433 1.43 6.518 3.73 8.65.697.645.844.955.533.924-.186-.018-.537-.16-1.033-.423-3.362-1.794-5.315-5.665-5.315-9.775V14.264c0-4.111 1.953-7.981 5.315-9.775.496-.265.847-.406 1.033-.424z"
            style={{ marker: 'none' }}
            display="inline"
            enableBackground="accumulate"
            opacity="1"
            overflow="visible"
            vectorEffect="none"
          ></path>
        </g>
        <g
          strokeDasharray="none"
          strokeMiterlimit="4"
          strokeOpacity="1"
        >
          <rect
            width="11.363"
            height="1.441"
            x="42.026"
            y="7.262"
            fill="#1e1e1e"
            fillOpacity="1"
            fillRule="nonzero"
            strokeDashoffset="0"
            strokeLinecap="round"
            strokeWidth="0.265"
            color="#000"
            display="inline"
            enableBackground="accumulate"
            opacity="1"
            overflow="visible"
            ry="0.721"
            style={{ marker: 'none' }}
            vectorEffect="none"
            visibility="visible"
          ></rect>
          <circle
            cx="57.915"
            cy="7.89"
            r="1.345"
            style={{ marker: 'none' }}
            fill="#2b2b2b"
            fillOpacity="1"
            fillRule="nonzero"
            strokeDashoffset="0"
            strokeLinecap="round"
            strokeWidth="0.026"
            color="#000"
            display="inline"
            enableBackground="accumulate"
            opacity="1"
            overflow="visible"
            vectorEffect="none"
            visibility="visible"
          ></circle>
          <circle
            cx="57.915"
            cy="7.89"
            r="1.077"
            style={{ marker: 'none' }}
            fill="#0a0d13"
            fillOpacity="1"
            fillRule="nonzero"
            strokeDashoffset="0"
            strokeLinecap="round"
            strokeWidth="0.026"
            color="#000"
            display="inline"
            enableBackground="accumulate"
            opacity="1"
            overflow="visible"
            vectorEffect="none"
            visibility="visible"
          ></circle>
          <circle
            cx="57.915"
            cy="7.89"
            r="0.821"
            style={{ marker: 'none' }}
            fill="#091427"
            fillOpacity="1"
            fillRule="nonzero"
            strokeDashoffset="0"
            strokeLinecap="round"
            strokeWidth="0.026"
            color="#000"
            display="inline"
            enableBackground="accumulate"
            opacity="1"
            overflow="visible"
            vectorEffect="none"
            visibility="visible"
          ></circle>
          <path
            fill="#235a91"
            fillOpacity="0.556"
            fillRule="evenodd"
            strokeLinecap="butt"
            strokeWidth="0.026"
            d="M57.35 7.34c-.098.01-.236.16-.246.451-.01.292.118.451.19.451.071 0 .368-.425.056-.901z"
            filter="url(#filter5343)"
          ></path>
          <path
            fill="#235a91"
            fillOpacity="0.556"
            fillRule="evenodd"
            strokeLinecap="butt"
            strokeWidth="0.026"
            d="M58.049 7.238c-.154.047-.183.296-.177.437.006.142.206.514.449.431.242-.082.283-.39.183-.596-.1-.207-.284-.354-.455-.272z"
            filter="url(#filter5347)"
          ></path>
          <path
            style={{ marker: 'none' }}
            fill="#0f0f0f"
            fillOpacity="1"
            fillRule="nonzero"
            strokeDashoffset="0"
            strokeLinecap="round"
            strokeWidth="0.026"
            d="M40.24 8.014a1.057 1.057 0 01-1.052 1.057 1.057 1.057 0 01-1.061-1.05 1.057 1.057 0 011.045-1.064 1.057 1.057 0 011.069 1.041l-1.057.016z"
            color="#000"
            display="inline"
            enableBackground="accumulate"
            opacity="1"
            overflow="visible"
            vectorEffect="none"
            visibility="visible"
          ></path>
          <path
            style={{ marker: 'none' }}
            fill="#101010"
            fillOpacity="1"
            fillRule="nonzero"
            strokeDashoffset="0"
            strokeLinecap="round"
            strokeWidth="0.031"
            d="M34.246 8.038a1.595 1.57 0 01-1.589 1.57 1.595 1.57 0 01-1.6-1.558 1.595 1.57 0 011.577-1.58 1.595 1.57 0 011.612 1.545l-1.595.023z"
            color="#000"
            display="inline"
            enableBackground="accumulate"
            opacity="1"
            overflow="visible"
            vectorEffect="none"
            visibility="visible"
          ></path>
        </g>
        <path
          style={{ marker: 'none' }}
          fill="url(#linearGradient5832)"
          fillOpacity="1"
          fillRule="nonzero"
          strokeDasharray="none"
          strokeDashoffset="0"
          strokeLinecap="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="0.089"
          d="M14.624 2.577c-2.299 0-4.437.658-6.242 1.792v1.505a10.897 10.897 0 016-1.785h66.619c2.22 0 4.28.657 6 1.785V4.37a11.685 11.685 0 00-6.241-1.792H40.794z"
          color="#000"
          display="inline"
          enableBackground="accumulate"
          opacity="1"
          overflow="visible"
          vectorEffect="none"
          visibility="visible"
        ></path>
        <path
          style={{ marker: 'none' }}
          fill="url(#linearGradient5832-3)"
          fillOpacity="1"
          fillRule="nonzero"
          strokeDasharray="none"
          strokeDashoffset="0"
          strokeLinecap="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="0.089"
          d="M14.624 188.384c-2.299 0-4.437-.658-6.242-1.792v-1.505a10.897 10.897 0 006 1.785h66.619c2.22 0 4.28-.657 6-1.785v1.505a11.685 11.685 0 01-6.241 1.792H40.794z"
          color="#000"
          display="inline"
          enableBackground="accumulate"
          opacity="1"
          overflow="visible"
          vectorEffect="none"
          visibility="visible"
        ></path>
        <path
          style={{ marker: 'none' }}
          fill={`url(#${imgId})`}
          fillOpacity="1"
          fillRule="nonzero"
          strokeDasharray="none"
          strokeDashoffset="0"
          strokeLinecap="round"
          strokeMiterlimit="4"
          strokeOpacity="0.953"
          strokeWidth="0.668"
          d="M55.78 22.201c-17.769 0-32.073 14.304-32.073 32.072V667.47c0 17.768 14.304 32.072 32.072 32.072h248.442c17.768 0 32.072-14.304 32.072-32.072V54.273c0-17.768-14.304-32.072-32.072-32.072h-31.373a5.358 5.358 0 00-5.358 5.358v2.466c0 9.654-7.77 17.426-17.424 17.426H109.934A17.386 17.386 0 0192.51 30.025V27.56a5.358 5.358 0 00-5.358-5.358H55.78z"
          color="#000"
          display="inline"
          enableBackground="accumulate"
          opacity="1"
          overflow="visible"
          transform="scale(.26458)"
          vectorEffect="none"
          visibility="visible"
        ></path>
        <path
          style={{ marker: 'none' }}
          fill="#0f0f0f"
          fillOpacity="1"
          fillRule="nonzero"
          strokeDasharray="none"
          strokeDashoffset="0"
          strokeLinecap="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="0.053"
          d="M66.398 7.87a2.133 2.11 0 01-2.125 2.109 2.133 2.11 0 01-2.14-2.094A2.133 2.11 0 0164.24 5.76a2.133 2.11 0 012.157 2.078l-2.133.031z"
          color="#000"
          display="inline"
          enableBackground="accumulate"
          opacity="1"
          overflow="visible"
          vectorEffect="none"
          visibility="visible"
        ></path>
      </g>
    </svg>
  );
};

const PHONE_WIDTH = 356.08;

const SCREEN_WIDTH = 348; //312.58; // PHONE_WIDTH - FRAME_WIDTH * 2;
const SCREEN_HEIGHT = 613;

const TOP_MARGIN = -26;
